export default __webpack_public_path__ + "static/media/selamat10.71057c48.svg";